"use client";

import React, { useEffect, useState } from "react";
import { TrendingUp, Shield, ChartPie, User, Settings, FileText, ArrowUpRight, Activity, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const recentActivityData = [{
  id: 1,
  title: "Berita Terverifikasi",
  date: "Hari ini, 10:24",
  amount: "+50 Poin",
  type: "credit"
}, {
  id: 2,
  title: "Komentar Disetujui",
  date: "Kemarin, 16:00",
  amount: "+5 Poin",
  type: "credit"
}, {
  id: 3,
  title: "Pembaruan Profil",
  date: "12 Okt 2023",
  amount: "Selesai",
  type: "debit"
}, {
  id: 4,
  title: "Bonus Kontributor",
  date: "01 Okt 2023",
  amount: "+100 Poin",
  type: "credit"
}];
const quickLinksData = [{
  id: "send-news",
  label: "Kirim Berita",
  icon: FileText,
  href: "/SendNewsPage"
}, {
  id: "profile",
  label: "Data Akun",
  icon: User,
  href: "#"
}, {
  id: "activity",
  label: "Aktivitas",
  icon: Activity,
  href: "#"
}];
export default function MemberDashboard() {
  const [scrollY, setScrollY] = useState(0);
  const {
    headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="160579" id="akun-saya" className="relative min-h-screen w-full overflow-hidden bg-background py-12 md:py-24">
      {}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-10 mix-blend-overlay transition-transform duration-75 ease-out dark:opacity-5" style={{
      backgroundImage: 'none',
      backgroundColor: 'var(--background)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      transform: `translateY(${scrollY * 0.15}px) scale(1.1)`
    }} aria-hidden="true" />
      
      {}
      <div className="pointer-events-none absolute top-0 left-1/4 h-[300px] w-[300px] md:h-[500px] md:w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-primary/5 blur-[80px] md:blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 right-1/4 h-[350px] w-[350px] md:h-[600px] md:w-[600px] translate-x-1/2 translate-y-1/2 rounded-lg bg-muted/10 blur-[100px] md:blur-[150px]" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[repeat(16,minmax(0,1fr))]">
          
          {}
          <div className="flex flex-col gap-10 md:gap-12 lg:col-span-12">
            
            {}
            <div ref={headerRef} className={`flex flex-col gap-4 md:gap-6 transition-all duration-1000 ${isHeaderVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
              <div className="flex items-center gap-2 text-sm font-sans font-medium tracking-widest text-muted-foreground uppercase">
                <Activity className="size-4 text-primary" />
                <span>Ringkasan Kontribusi</span>
              </div>
              
              <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-end sm:justify-between">
                <h2 className="font-serif text-4xl sm:text-5xl font-medium tracking-tight text-foreground md:text-7xl lg:text-8xl">
                  Budi Santoso
                </h2>
                
                <div className="flex items-center gap-3 rounded-lg bg-primary/10 px-4 py-2 text-primary backdrop-blur-sm border border-primary/20">
                  <Shield className="size-5" />
                  <span className="font-sans text-base md:text-lg font-semibold">Kontributor</span>
                </div>
              </div>
            </div>

            {}
            <div ref={cardsRef} className={`grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8 transition-all duration-1000 delay-200 ${areCardsVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
              {}
              <Card className="w-full overflow-hidden border-border bg-card/60 shadow-sm backdrop-blur-xl px-4 md:px-0">
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2 text-xl font-serif">
                      <ChartPie className="size-5 text-primary" />
                      Statistik Berita
                    </CardTitle>
                    <Button variant="ghost" size="icon" className="h-8 w-8 rounded-lg hover:bg-muted hover:text-primary transition-colors duration-400">
                      <ArrowUpRight className="size-4" />
                    </Button>
                  </div>
                  <CardDescription className="font-sans">Status publikasi artikel Anda bulan ini.</CardDescription>
                </CardHeader>
                <CardContent className="flex flex-col gap-6">
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between text-sm">
                      <span className="flex items-center gap-2 font-sans font-medium">
                        <FileText className="size-4 text-primary" />
                        Artikel Terbit
                      </span>
                      <span className="font-mono text-muted-foreground">85%</span>
                    </div>
                    <Progress value={85} className="h-1 md:h-1.5 bg-muted" />
                  </div>
                  
                  <div className="flex flex-col gap-2">
                    <div className="flex items-center justify-between text-sm">
                      <span className="flex items-center gap-2 font-sans font-medium">
                        <Zap className="size-4 text-primary" />
                        Draft Pending
                      </span>
                      <span className="font-mono text-muted-foreground">15%</span>
                    </div>
                    {}
                    <div className="relative h-1 md:h-1.5 w-full overflow-hidden rounded-lg bg-muted">
                      <div className="h-full w-[15%] bg-primary transition-all" />
                    </div>
                  </div>
                </CardContent>
              </Card>

              {}
              <Card className="w-full overflow-hidden border-border bg-card/60 shadow-sm backdrop-blur-xl px-4 md:px-0">
                <CardHeader className="pb-4">
                  <div className="flex items-center justify-between">
                    <CardTitle className="flex items-center gap-2 text-xl font-serif">
                      <Activity className="size-5 text-primary" />
                      Aktivitas Terbaru
                    </CardTitle>
                    <Button variant="ghost" size="sm" className="h-8 text-xs hover:bg-muted hover:text-primary transition-colors duration-400">
                      Lihat Semua
                    </Button>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="flex flex-col gap-4">
                    {recentActivityData.map((activity, i) => <div key={activity.id} data-index={i} className="flex items-center justify-between group border-b border-muted/50 pb-2 last:border-0 last:pb-0">
                        <div className="flex flex-col gap-1">
                          <span className="text-sm font-sans font-medium text-foreground group-hover:text-primary transition-colors duration-400">
                            {activity.title}
                          </span>
                          <span className="text-xs text-muted-foreground font-sans">
                            {activity.date}
                          </span>
                        </div>
                        <span className={`font-mono text-sm font-medium ${activity.type === 'credit' ? 'text-primary' : 'text-foreground'}`}>
                          {activity.amount}
                        </span>
                      </div>)}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6 lg:col-span-4 mt-12 lg:mt-0">
            <div className="lg:sticky lg:top-24 flex flex-col gap-6 md:gap-8">
              <h3 className="text-sm font-sans font-medium tracking-widest text-muted-foreground uppercase mb-2">
                Akses Cepat
              </h3>
              
              <div className="flex flex-col gap-3">
                {quickLinksData.map((link, i) => <Link key={link.id} to={link.href} data-index={i} className="block">
                    <Button variant="outline" className="w-full justify-start h-12 md:h-14 px-4 md:px-6 border-border bg-card/40 backdrop-blur-md shadow-sm hover:bg-muted hover:text-foreground hover:border-primary/50 transition-all duration-400 group gap-2 md:gap-3">
                      <link.icon className="size-5 text-primary group-hover:scale-110 transition-transform duration-400" />
                      <span className="text-sm md:text-base font-sans font-medium">{link.label}</span>
                      <ArrowUpRight className="ml-auto size-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-400" />
                    </Button>
                  </Link>)}
              </div>

              <Card className="mt-4 border-primary/20 bg-primary/5 backdrop-blur-md px-4 md:px-0">
                <CardContent className="p-6 flex flex-col items-center text-center gap-4">
                  <div className="rounded-lg bg-primary/10 p-3">
                    <Shield className="size-6 text-primary" />
                  </div>
                  <div>
                    <h4 className="font-serif font-medium text-foreground">Bantuan Redaksi</h4>
                    <p className="text-sm font-sans text-muted-foreground mt-1">Hubungi tim editor untuk koordinasi liputan.</p>
                  </div>
                  <Button className="w-full mt-2 bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">Hubungi Kami</Button>
                </CardContent>
              </Card>
            </div>
          </div>

        </div>
      </div>
    </section>;
}